<div class="flex-container container" fxLayout="row">
    <div fxflex="20" class="left-sidebar" fxlayoutalign="center center"></div>
    <div fxflex="80" class="right-sidebar" fxlayoutalign="center center">
        <div class="page-content" fxlayoutalign="center center">
            <div fxLayout="row" class="image-container" fxlayoutalign="center center" alt="Brand Logo">
                <img mat-card-image src="{{logoUrl}}" alt="star image">
            </div>
            <div class="subtitle">What is your employee identification code?</div>
            <form [formGroup]="companyIdentfierForm" (ngSubmit)="onSubmit()">
                <div>
                    <input class="input-text" type="text" formControlName="companyIdentfier" required>
                    <div *ngIf="companyIdentfier?.touched || companyIdentfier?.dirty">
                        <div *ngIf="companyIdentfier?.errors?.required" class="error" >
                            Please enter company identifier
                        </div>
                        <div *ngIf="companyIdentfier?.invalid && companyIdentfier?.errors?.pattern" class="error" >
                            Please enter alpha numeric characters only
                        </div>
                    </div>                   
                </div>

                <div>
                    <button [disabled]="!companyIdentfierForm.valid" class="submit-btn primary-btn-action" type="submit" mat-flat-button color="primary">
                        SUBMIT
                    </button>
                </div>
                <div class="row" class="tcb-content">
                    Texas Capital Bank products are available by employer identification code. By inputting your
                    employer identification code, we can make sure the information you see is accurate.
                </div>
            </form>

        </div>

    </div>
    <div class="start-image-container">
        <img mat-card-image src="{{imagePath}}" alt="star image">
    </div>

</div>